import * as React from 'react';
import { Tooltip } from '../Tooltip';
export const Wrapper = ({ badge, layout, children }) => {
    if (layout === 'icon-only') {
        return (React.createElement(Tooltip, { message: badge.title },
            React.createElement("div", { className: "members-badges-lib-style-wrapper" }, children)));
    }
    else {
        return React.createElement("div", { className: "members-badges-lib-style-wrapper" }, children);
    }
};
//# sourceMappingURL=Wrapper.js.map